import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAfkmJfKIBSGgbjziCfdDOMUjIdqAX1Ym0",
  authDomain: "inventorymyty.firebaseapp.com",
  projectId: "inventorymyty",
  storageBucket: "inventorymyty.firebasestorage.app",
  messagingSenderId: "527495560002",
  appId: "1:527495560002:web:ebb0c18f46995d71c566db"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);